import React, { useCallback, useEffect, useState } from 'react';
import { SystemWarning } from './SystemWarning';
import { SalvButton, Size } from '@salvapp/ui-components';
import { faRefresh } from '@fortawesome/pro-solid-svg-icons';

export const VersionWarnings = () => {
  const currentVersion = process.env.FE_APP_BUILD_TIME ? parseInt(process.env.FE_APP_BUILD_TIME) : Infinity;
  const [versionShouldBe, setVersionShouldBe] = useState(0);

  const fetchVersion = useCallback(async () => {
    try {
      const response = await fetch('/VERSION');
      const requiredVersion = parseInt(await response.text());
      setVersionShouldBe(requiredVersion);
    } catch (_) {
      console.warn('Failed to load minimum required FE version');
    }
  }, [setVersionShouldBe]);

  useEffect(() => {
    if (versionShouldBe === 0) {
      fetchVersion();
    }
    const timer = setInterval(fetchVersion, 10 * 60 * 1000);
    return () => clearTimeout(timer);
  }, [versionShouldBe, fetchVersion]);

  return (
    <>
      {versionShouldBe > currentVersion && (
        <SystemWarning>
          <span>You are currently using older version of Salv. Please refresh the page to update.</span>
          <SalvButton
            size={Size.EXTRA_SMALL}
            variant='danger'
            // @ts-ignore
            onClick={() => window.location.reload(true)}
            iconLeft={faRefresh}
            label='Update'
          />
        </SystemWarning>
      )}
    </>
  );
};
